import { __extends } from "tslib";
import { BaseModel } from '@/core/standard/BaseModel';
import UnitServices from '@/modules/units/UnitService';
var unit = {
  name: '',
  type: 'quantity',
  value: null,
  unit_reference: null
};

var UnitModel =
/** @class */
function (_super) {
  __extends(UnitModel, _super);

  function UnitModel() {
    var _this = _super.call(this, unit, UnitServices) || this;

    _this.modelName = 'Unidades';
    _this.request = 'JSON';
    return _this;
  }

  return UnitModel;
}(BaseModel);

export default UnitModel;